export default __webpack_public_path__ + "static/media/emailIconWhiteBackground3x.f95d3079.png";